import { Card, CardImg, CardBody, CardTitle } from "reactstrap";
import { useState } from "react";


export default function BookCard({ coverUrl, title, author }) {
    const [isHovered, setIsHovered] = useState(false);


    return (
            <Card className="shadow-sm mb-3 book-card" 
            style={{ 
                width: "100%", 
                maxWidth: "12rem",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                transform: isHovered ? "translateY(-5px)" : "translateY(0)",
                boxShadow: isHovered ? "0 10px 20px rgba(0,0,0,0.2)" : "0 4px 8px rgba(0,0,0,0.1)",
                cursor: "pointer",
                borderColor: 'black'
            }}
             onMouseEnter={() => setIsHovered(true)}
             onMouseLeave={() => setIsHovered(false)}
             onTouchStart={() => setIsHovered(true)}
             onTouchEnd={() => setIsHovered(false)}
            >
          
            <CardImg
                top
                src={coverUrl}
                alt={title}
                style={{ 
                    height: "260px", 
                    objectFit: "cover",
                    transition: "filter 0.3s ease",
                    filter: isHovered ? "brightness(1.05)" : "brightness(1)" 
                }}
            />
            <CardBody className="p-2 text-center" style={{ background: 'black', color: 'white' }}>
                <CardTitle tag="h6" className="mb-1 text-truncate text-color-site text-font-family" title={title}>
                    {title}
                </CardTitle>
                <div className="small text-color-site text-font-family" title={author}>
                    {author}
                </div>
            </CardBody>
            </Card>
        );
}